import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { FormControl, FormLabel, FormErrorMessage, Checkbox, HStack } from "@chakra-ui/react";
import Spinner from "@inspire/ui/chakra/Spinner";
var StandaloneCheckbox = function(_param) {
    var isChecked = _param.isChecked, onLabel = _param.onLabel, offLabel = _param.offLabel, label = _param.label, onChange = _param.onChange, isDisabled = _param.isDisabled, errorMessage = _param.errorMessage, formControlProps = _object_without_properties(_param, [
        "isChecked",
        "onLabel",
        "offLabel",
        "label",
        "onChange",
        "isDisabled",
        "errorMessage"
    ]);
    var ref = useState(null), randomString = ref[0], setRandomString = ref[1];
    var ref1 = useState(false), isToggling = ref1[0], setIsToggling = ref1[1];
    useEffect(function() {
        setRandomString((Math.random() + 1).toString(36).substring(7));
    }, []);
    return /*#__PURE__*/ _jsxs(FormControl, _object_spread_props(_object_spread({
        isDisabled: isDisabled
    }, formControlProps), {
        children: [
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 3,
                children: [
                    isToggling ? /*#__PURE__*/ _jsx(Spinner, {
                        size: "sm"
                    }) : /*#__PURE__*/ _jsx(Checkbox, {
                        id: randomString,
                        isChecked: isChecked && !isToggling || !isChecked && isToggling,
                        isDisabled: isToggling || isDisabled,
                        onChange: function() {
                            var _ref = _async_to_generator(function(e) {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!onChange) return [
                                                3,
                                                2
                                            ];
                                            setIsToggling(true);
                                            return [
                                                4,
                                                onChange(e)
                                            ];
                                        case 1:
                                            _state.sent();
                                            setIsToggling(false);
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(e) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    }),
                    /*#__PURE__*/ _jsx(FormLabel, {
                        htmlFor: randomString,
                        children: label !== null && label !== void 0 ? label : isChecked ? onLabel : offLabel
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ _jsx(FormErrorMessage, {
                children: errorMessage
            })
        ]
    }));
};
export default StandaloneCheckbox;
